module.exports = __webpack_public_path__ + "img/reserved_selected.502ce0d5.svg";